import React, { useState } from 'react';
import { Button, Checkbox } from '@material-ui/core';
import { btnColor } from '../../GlobalState';
import { useRecoilState } from 'recoil';
import { log } from '../../utils';
type Tprops = {
  isDisabled: boolean;
  onClickMerchandise: (isChecked: boolean) => void;
  onClickOutsource: (isChecked: boolean) => void;
  onClickSiteContact: () => void;
  RegisterQuotation: () => void;
};
export const OtherDocumentCreationButtons: React.FC<Tprops> = (
  props: Tprops
) => {
  const {
    isDisabled,
    onClickMerchandise,
    RegisterQuotation,
    onClickOutsource,
    onClickSiteContact
  } = props;
  const [buttonColor] = useRecoilState(btnColor);
  const [isChecked, setIsChecked] = useState(true);
  const handleCheckboxChange = (event: any) => {
    setIsChecked(event.target.checked);
  };
  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '10px 0px'
          }}
        >
          <div style={{ marginRight: 15 }}>選択項目の</div>
          <Button
            disabled={isDisabled}
            style={{ backgroundColor: buttonColor, marginRight: 15 }}
            variant='contained'
            color='primary'
            onClick={() => {
              log.info('estimate to merchandise');
              onClickMerchandise(isChecked);
            }}
          >
            商品発注書を作成
          </Button>
          <Button
            disabled={isDisabled}
            style={{ backgroundColor: buttonColor, marginRight: 15 }}
            variant='contained'
            color='primary'
            onClick={() => {
              log.info('estimate to outsource');
              onClickOutsource(isChecked);
            }}
          >
            外注発注書を作成
          </Button>
          <Button
            disabled={isDisabled}
            style={{ backgroundColor: buttonColor, marginRight: 15 }}
            variant='contained'
            color='primary'
            onClick={() => {
              log.info('estimate to site-contact');
              onClickSiteContact();
            }}
          >
            現場連絡表を作成
          </Button>
          <Button
            disabled={isDisabled}
            style={{ backgroundColor: buttonColor, marginRight: 15 }}
            variant='contained'
            color='primary'
            onClick={() => {
              RegisterQuotation();
            }}
          >
            見積書マスタ作成
          </Button>
        </div>
        <div>
          <Checkbox
            checked={isChecked}
            color='default'
            style={{ marginRight: 16 }}
            onChange={handleCheckboxChange}
          />
          発注書に大項目を転記する
        </div>
      </div>
    </>
  );
};
